/** Normalize show_redeem_user_mobile from user-details_v2 (any nesting). */
export function resolveShowRedeemUserMobile(payload: any): boolean {
  if (payload == null) return false

  const candidates = [
    payload.show_redeem_user_mobile,
    payload.user?.show_redeem_user_mobile,
    payload.data?.show_redeem_user_mobile,
    payload.data?.user?.show_redeem_user_mobile,
    payload.business?.show_redeem_user_mobile,
  ]

  for (const value of candidates) {
    if (value === true || value === 1 || value === '1') return true
    if (value === 'true' || value === 'True') return true
    if (value === false || value === 0 || value === '0') return false
    if (value === 'false' || value === 'False') return false
  }

  return false
}
